import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Offer } from '../_models/offer';

@Injectable({ providedIn: 'root' })
export class ReviewService {
    constructor(
        private router: Router,
        private http: HttpClient
    ) {}

    single(id: any): any {
    	return this.http.get<any[]>(`${environment.apibase}review/${id}`);
    }

    sendReviewForParticipation(id: any, formValues:any): any {
      // On ajoute un paramètre pour effectuer l'appel en mode notation sur 10 afin de prévoir le cas de figure où l'utilisateur n'as pas encore
      // mis à jour son application, auquel cas, il enverra des notes comprises entre 1 et 5
      formValues.version = 2;
    	return this.http.post(`${environment.apibase}review/add/${id}`, formValues);
    }

    sendGlobalReview(formValues:any): any {
    	return this.http.post(`${environment.apibase}review/add-global`, formValues);
    }

    sendPublicGlobalReview(formValues:any): any {
    	return this.http.post(`${environment.apibase}review/add-global-public`, formValues);
    }

    list(): any {
    	return this.http.get<any[]>(`${environment.apibase}reviews`, {});
    }
}